import React from 'react';
import dayjs from 'dayjs';
import { getUserTimezoneOffset } from '@/utils/dateTimeUtils';

interface RadarTimestampBadgeProps {
  timestamp: number;
}

const RadarTimestampBadge: React.FC<RadarTimestampBadgeProps> = ({ timestamp }) => (
  <div
    className="rainfallTimeContainer"
    style={{
      position: 'absolute',
      right: '23px',
      bottom: '25px',
      fontSize: 12,
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      padding: '8px',
      borderRadius: '4px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    }}
  >
    <span>{dayjs.unix(timestamp).utc().add(getUserTimezoneOffset() ?? 0, 'hour').format('YYYY/MM/DD - hh:mm a')}</span>
  </div>
);

export default RadarTimestampBadge;
